import {z as r} from 'zod';

export const onboardingLocalstorageSchema = r.boolean();
